import Aos from "aos";

function aos() {
    Aos.init({
        disable: 'mobile',
    })
}

export default aos;